import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import {
  siteAuditDashboardNewBlankSx,
  siteProgressSecondBoxSx
} from 'src/content/siteAudit/siteAuditCSS';
import {
  blogPostGscPageTexts,
  paths,
  siteAuditDashboardNewBlank
} from 'src/common/config/TextMessage';
import { useNavigate } from 'react-router';
import {
  keywordResearchDashBoardCss,
  UpgradePlanLiteModalSxs
} from 'src/content/keywordResearch/keywordResearchCSS';
import { openNewTab } from 'src/common/config/FunctionHelper';
import AddIcon from '@mui/icons-material/Add';

interface OrbitAgentBlankStateProps {
  title: string;
}

export default function OrbitAgentBlankState({ title }: OrbitAgentBlankStateProps) {
  const navigate = useNavigate();
  return (
    <>
      <Box sx={siteAuditDashboardNewBlankSx?.titleBoxSx}>
        <Typography sx={siteAuditDashboardNewBlankSx?.titleSx}>
          {title}
        </Typography>
        <Button
          onClick={() => {
            navigate(paths?.onBoarding);
          }}
          variant="contained"
          sx={siteAuditDashboardNewBlankSx?.btnSx}
          startIcon={<AddIcon />}
        >
          {siteAuditDashboardNewBlank?.addSite}
        </Button>
      </Box>
      <Card sx={keywordResearchDashBoardCss?.card}>
        <CardContent sx={keywordResearchDashBoardCss?.cardContent}>
          <Box sx={siteAuditDashboardNewBlankSx?.textsBoxSx}>
            <Typography sx={siteAuditDashboardNewBlankSx?.addYourSiteSx}>
              {siteAuditDashboardNewBlank?.addYourSite}
            </Typography>
            <Typography sx={siteAuditDashboardNewBlankSx?.descSx}>
              {siteAuditDashboardNewBlank?.desc}
            </Typography>
          </Box>
          <img
            draggable={false}
            src={
              process.env.PUBLIC_URL +
              `/static/images/icons/ai-dashboard-blank.png`
            }
            style={{ width: '100%' }}
          />
          <Box
            sx={{
              ...siteAuditDashboardNewBlankSx?.watchTutorialBoxSx
            }}
          >
            <Typography
              onClick={() => {
                openNewTab(blogPostGscPageTexts?.watchTutorialUrl);
              }}
              sx={siteProgressSecondBoxSx?.watchTutorialText}
            >
              {blogPostGscPageTexts?.watchTutorial}
            </Typography>
            <img
              style={UpgradePlanLiteModalSxs?.img}
              src={
                process.env.PUBLIC_URL +
                `/static/images/icons/shareSquareIcon.svg`
              }
              alt="icon"
              onClick={() => {
                openNewTab(blogPostGscPageTexts?.watchTutorialUrl);
              }}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}
